/**
 * Fold Videos Player - Custom play/pause controls for video cards
 */
(function () {
  if (!window.customElements || window.customElements.get('fold-videos-player')) return;

  class FoldVideosPlayerEl extends HTMLElement {
    constructor() {
      super();
      this.video = null;
      this.playBtn = null;
      this.pauseBtn = null;
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      this.video = this.querySelector('.fold-videos__video');
      this.playBtn = this.querySelector('.fold-videos__play');
      this.pauseBtn = this.querySelector('.fold-videos__pause');

      if (!this.video || !this.playBtn || !this.pauseBtn) return;

      this.setupEvents();
      this.updateState(this.video.paused ? 'paused' : 'playing');
    }

    setupEvents() {
      this.playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.play();
      });
      this.pauseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.pause();
      });
      this.addEventListener('click', (e) => {
        if (e.target.closest('.fold-videos__play') || e.target.closest('.fold-videos__pause')) return;
        this.toggle();
      });
      this.video.addEventListener('play', () => this.updateState('playing'));
      this.video.addEventListener('pause', () => this.updateState('paused'));
      this.video.addEventListener('ended', () => this.updateState('paused'));
    }

    updateState(state) {
      this.classList.remove('playing', 'paused');
      this.classList.add(state);
    }

    async play() {
      try {
        await this.video.play();
        this.updateState('playing');
      } catch (err) {
        this.updateState('paused');
      }
    }

    pause() {
      this.video.pause();
      this.updateState('paused');
    }

    toggle() {
      this.video.paused ? this.play() : this.pause();
    }
  }

  customElements.define('fold-videos-player', FoldVideosPlayerEl);
})();
